import { PRICING_TEAM_EDITING_RIGHTS_EMAIL } from '../../../shared/constants';

const filterOutPricingEmail = (email: string): boolean =>
  email !== PRICING_TEAM_EDITING_RIGHTS_EMAIL;

export default filterOutPricingEmail;
